<template>
  <button @click="goGame" class="game-element">
    <div class="icon-wrapper">
      <div class="info">
        <div v-if="game.details.isZoom===1" style="margin: 0 2px" class="home">
          <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.75 3.09375C2.75 2.904 2.904 2.75 3.09375 2.75H5.15625C5.346 2.75 5.5 2.904 5.5 3.09375V4.46875C5.5 4.6585 5.346 4.8125 5.15625 4.8125H3.09375C2.904 4.8125 2.75 4.6585 2.75 4.46875V3.09375Z" fill="#06364B"/>
            <path d="M8.65273 3.15273C8.91059 2.89487 9.26033 2.75 9.625 2.75C9.98967 2.75 10.3394 2.89487 10.5973 3.15273C10.8551 3.41059 11 3.76033 11 4.125C11 4.48967 10.8551 4.83941 10.5973 5.09727C10.3394 5.35513 9.98967 5.5 9.625 5.5C9.26033 5.5 8.91059 5.35513 8.65273 5.09727C8.39487 4.83941 8.25 4.48967 8.25 4.125C8.25 3.76033 8.39487 3.41059 8.65273 3.15273Z" fill="#06364B"/>
            <path d="M2.75 6.53125C2.75 6.3415 2.904 6.1875 3.09375 6.1875H5.15625C5.346 6.1875 5.5 6.3415 5.5 6.53125V7.90625C5.5 8.096 5.346 8.25 5.15625 8.25H3.09375C2.904 8.25 2.75 8.096 2.75 7.90625V6.53125Z" fill="#06364B"/>
            <path d="M6.875 7.71155C6.875 6.8123 8.12281 6.1875 9.625 6.1875C11.1272 6.1875 12.375 6.8123 12.375 7.71155V7.90625C12.375 8.096 12.221 8.25 12.0312 8.25H7.21875C7.029 8.25 6.875 8.096 6.875 7.90625V7.71155Z" fill="#06364B"/>
            <rect x="0.5" y="0.5" width="13.6667" height="10" rx="1.5" stroke="#06364B"/>
          </svg>
        </div>
      <div v-if="game.details.isRest=== 1" style="margin: 0 2px" class=" break">
<!--        <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--          <path d="M4.50021 0C3.81243 0 3.24971 0.586871 3.24971 1.30416C3.24971 2.02144 3.81243 2.60831 4.50021 2.60831C5.18798 2.60831 5.7507 2.02144 5.7507 1.30416C5.7507 0.586871 5.18798 0 4.50021 0ZM4.50021 0.521663C4.91736 0.521663 5.2505 0.869099 5.2505 1.30416C5.2505 1.73922 4.91736 2.08665 4.50021 2.08665C4.08305 2.08665 3.74991 1.73922 3.74991 1.30416C3.74991 0.869099 4.08305 0.521663 4.50021 0.521663ZM0.748721 1.83397C0.654934 1.83295 0.562124 1.84722 0.475176 1.88288C0.296394 1.95725 0.142036 2.10193 0.0609491 2.29858C-0.102201 2.69288 0.0736494 3.15647 0.451729 3.3256C0.45466 3.32866 0.456614 3.3307 0.459544 3.33375L3.24971 4.44229V5.81165L0.991005 8.16729C0.668612 8.50351 0.668612 9.06186 0.991005 9.39808C1.3134 9.73431 1.84877 9.73431 2.17116 9.39808L4.50021 6.96909L6.82925 9.39808C7.15165 9.73431 7.68702 9.73431 8.00941 9.39808C8.3318 9.06186 8.3318 8.50351 8.00941 8.16729L5.7507 5.81165V4.44229L8.54087 3.33375C8.5438 3.3307 8.54575 3.32866 8.54869 3.3256C8.92677 3.15647 9.10164 2.69288 8.93947 2.29858C8.77925 1.91039 8.3445 1.7331 7.97033 1.89103V1.88288L7.9547 1.89103L5.44589 2.86915H3.55452L1.04571 1.89103L1.03008 1.88288V1.89103C0.93825 1.85231 0.842509 1.83499 0.748721 1.83397ZM0.748721 2.34748C0.781938 2.3485 0.818085 2.35767 0.850324 2.37194C0.853255 2.37194 0.855209 2.37194 0.85814 2.37194L3.42165 3.37451C3.44901 3.3847 3.47832 3.39081 3.50763 3.39081H5.49279C5.5221 3.39081 5.5514 3.3847 5.57876 3.37451L8.14227 2.37194C8.14521 2.37194 8.14716 2.37194 8.15009 2.37194C8.27905 2.31386 8.42266 2.36684 8.47834 2.50235C8.53305 2.63582 8.48616 2.78458 8.36111 2.84469C8.35916 2.84571 8.35525 2.84367 8.3533 2.84469L5.41463 4.01844C5.31596 4.05613 5.2505 4.15394 5.2505 4.26296V5.92577C5.25148 5.99301 5.2759 6.0572 5.32084 6.10509L7.65771 8.54223C7.7896 8.67978 7.7896 8.89374 7.65771 9.03129C7.52582 9.16884 7.32066 9.16884 7.18877 9.03129L4.67997 6.41482C4.63307 6.36388 4.56762 6.33535 4.50021 6.33535C4.4328 6.33535 4.36734 6.36388 4.32045 6.41482L1.81164 9.03129C1.67975 9.16884 1.47459 9.16884 1.34271 9.03129C1.21082 8.89374 1.21082 8.67978 1.34271 8.54223L3.67957 6.10509C3.72451 6.0572 3.74893 5.99301 3.74991 5.92577V4.26296C3.74991 4.15394 3.68445 4.05613 3.58578 4.01844L0.647119 2.84469C0.645165 2.84367 0.641257 2.84571 0.639303 2.84469C0.514254 2.78458 0.46736 2.63481 0.522069 2.50235C0.550401 2.43511 0.596317 2.38824 0.654934 2.36379C0.684243 2.35156 0.715505 2.34646 0.748721 2.34748ZM4.50021 9.65076C3.64733 9.65076 2.92927 9.86269 2.92927 9.86269C2.79543 9.90345 2.71825 10.0491 2.75733 10.1887C2.79641 10.3283 2.93611 10.4088 3.06995 10.3681C3.06995 10.3681 3.72744 10.1724 4.50021 10.1724C5.27297 10.1724 5.93046 10.3681 5.93046 10.3681C6.0643 10.4088 6.20401 10.3283 6.24308 10.1887C6.28216 10.0491 6.20498 9.90345 6.07114 9.86269C6.07114 9.86269 5.35308 9.65076 4.50021 9.65076ZM4.50021 10.6941C2.53752 10.6941 0.889402 11.501 0.889402 11.501C0.764353 11.5642 0.711598 11.7211 0.772168 11.8515C0.832739 11.9819 0.983189 12.037 1.10824 11.9738C1.10824 11.9738 2.6694 11.2158 4.50021 11.2158C6.33101 11.2158 7.89218 11.9738 7.89218 11.9738C8.01722 12.037 8.16768 11.9819 8.22825 11.8515C8.28882 11.7211 8.23606 11.5642 8.11101 11.501C8.11101 11.501 6.4629 10.6941 4.50021 10.6941Z" fill="#06364B"/>-->
<!--        </svg>-->
        <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.78565 0.966797C2.67655 0.966797 0.966797 2.67655 0.966797 4.78565C0.966797 6.89474 2.67655 8.60449 4.78565 8.60449C6.89474 8.60449 8.60449 6.89474 8.60449 4.78565C8.60449 2.67655 6.89474 0.966797 4.78565 0.966797ZM0 4.78565C0 2.14261 2.14261 0 4.78565 0C7.42868 0 9.57129 2.14261 9.57129 4.78565C9.57129 7.42868 7.42868 9.57129 4.78565 9.57129C2.14261 9.57129 0 7.42868 0 4.78565Z" fill="#06364B"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11 4.78027C11.267 4.78027 11.4834 4.9967 11.4834 5.26367C11.4834 8.17079 9.12685 10.5273 6.21973 10.5273C5.95275 10.5273 5.73633 10.3109 5.73633 10.0439C5.73633 9.77697 5.95275 9.56055 6.21973 9.56055C8.5929 9.56055 10.5166 7.63684 10.5166 5.26367C10.5166 4.9967 10.733 4.78027 11 4.78027Z" fill="#06364B"/>
          <path d="M4.78613 5.7417C5.31415 5.7417 5.74219 5.31366 5.74219 4.78564C5.74219 4.25763 5.31415 3.82959 4.78613 3.82959C4.25812 3.82959 3.83008 4.25763 3.83008 4.78564C3.83008 5.31366 4.25812 5.7417 4.78613 5.7417Z" fill="#06364B"/>
          <path d="M4.78516 9.08789C2.87305 9.08789 0.960938 7.65381 0.960938 7.65381L1.32185 10.1792C1.38877 10.6501 1.79223 11 2.26834 11H7.30245C7.77809 11 8.18154 10.6501 8.24894 10.1792L8.60938 7.65381C8.60938 7.65381 6.69727 9.08789 4.78516 9.08789Z" fill="#06364B"/>
        </svg>

      </div>
      <div v-if="game.details.isHome=== 1" style="margin: 0 2px"  class="home">
        <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 0L5.68565 0.297663L0 5.9262L0.628702 6.54859L1.18907 5.99385V11H5.12528V6.67036H6.87472V11H10.8109V5.99385L11.3713 6.54859L12 5.9262L6.31435 0.297663L6 0ZM6 1.23124L9.93622 5.12792V10.1341H7.74943V5.80443H4.25057V10.1341H2.06378V5.12792L6 1.23124Z" fill="#06364B"/>
        </svg>
      </div>
      </div>
      <img :src="game.details.img" alt="">
      <div v-if="game.stats.played>0" class="counter">{{game.stats.played}}</div>
    </div>
    <div class="name">{{translated ? translated : game.details.translation[0].data.name}}</div>
  </button>
</template>

<script>
export default {
  name: "GiftElement",
  props:{
    game: {},
    gifts:{},
  },
  data(){
    return{

    }
  },
  computed:{
    translated(){
      if (this.$store.getters['lang-store/data']){
        return this.game.details.translation.find(item=>{
          if(this.$store.getters['lang-store/data']=='eng')
            {
              return item.langKey === "en"
            }
            else
            {
            return item.langKey === this.$store.getters['lang-store/data']
            }
        }).data.name
      }
    },
  },
  methods:{
    goGame(){
      this.$router.push({name: 'targeted-playlist', params: { id_playlist: this.game.id_playlist , gifts: this.gifts, infinity: true }});
    }
  },
}
</script>

<style scoped lang="scss">
  //
.game-element {
  margin: 8px 0!important;
  position: relative;
  height: 120px;
  width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .icon-wrapper{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90px;
    height: 90px;

    background: #FFFFFF;
    border-radius: 5px;
  }
  .name{
    font-size: 16px;
    text-align: center;
    color: #FFFFFF;
    margin-top: 7px;
    width: 126px;
  }
  img{
    width: 50px;
    height: 50px;
  }
  .info{
    top: 0;
    left: 4px;
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    .home{
      margin-right: 4px;
    }
  }
  .counter{
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #8CC63F;
    border: 1px solid #FFFFFF;
    bottom: 4px;
    left: 4px;
    font-size: 10px;
    text-align: center;
    color: #FFFFFF;
  }
}
</style>